import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { PencilIcon, ChevronUpIcon, ChevronDownIcon } from '@heroicons/react/24/solid'
import { InformationCircleIcon, TrashIcon } from '@heroicons/react/24/outline'
import { Spinner } from '@/components/ui'
import { useDetailContext } from '@/components/DetailTemplate'
import { formatDate, formatPrice } from '@/utils/formatters'
import { setInterventionInEdition, deleteIntervention } from './interventionsSlice'
import ResumeView from './Resume'
import ShowView from './Show'


export default ({item, withBienAddress = false}) => {
  const dispatch = useDispatch()
  const detailContext = useDetailContext()
  const deleting = useSelector( state => state.interventions.loadingStatus.delete )
  const [view, setView] = useState('resume')
  const [ showConfirmDialog, setShowConfirmDialog ] = useState(false)
  const [ deleteFired, setDeleteFired ] = useState(false)

  const toggleView = () => {
    setView(view === 'resume' ? 'show' : 'resume')
  }

  const handleEditClick = () => {
    dispatch(setInterventionInEdition(item))
    detailContext.setModalVisible(true)
  }

  const handleDeleteClick = (e) => {
    setShowConfirmDialog(true)
  }

  const confirmDelete = () => {
    setDeleteFired(true)
    dispatch(deleteIntervention(item))
  }

  const cancelDelete = () => {
    setShowConfirmDialog(false)
  }

  useEffect(() => {
    if(!deleting && deleteFired) {
      setShowConfirmDialog(false)
    }
  }, [deleting, deleteFired])

  return (
    <div className={`relative mb-2 bg-base-200 ${withBienAddress ? "pt-9" : ""}`} data-id={item.id} data-model="intervention">
      {view === 'resume' ? (
        <ResumeView intervention={item} />
      ) : (
        <ShowView intervention={item} />
      )}

      <div className={`absolute top-4 flex ${withBienAddress ? "left-4 w-full justify-between items-center pr-8" : "right-4 flex-col items-center"}`}>
        { withBienAddress && (
          <div className='flex flex-nowrap items-center font-bold p-1 hover:bg-primary-300'>
            <a
              className='btn btn-square btn-ghost btn-xs p-1 hover:bg-primary-400'
              href={`/biens/${item.bien_id}`}
              title="Aller sur la fiche du bien"
            >
              <InformationCircleIcon/>
            </a>
            <div className="flex flex-col">
              { item.bien.codage_interne }
            </div>
          </div>
        )}
        <button 
          onClick={toggleView}
          className="btn btn-sm btn-ghost btn-square hover:bg-primary-400"
          title={view === 'resume' ? "Voir les détails" : "Masquer les détails"}
        >
          {view === 'resume' ? <ChevronDownIcon/> : <ChevronUpIcon/>}
        </button>
      </div>

      <div className="absolute bottom-4 right-4 flex flex-row items-center">
        <button className="btn btn-sm btn-ghost btn-square p-2 hover:bg-primary-400"
          title="Modifier l'intervention"
          onClick={handleEditClick}
        >
          <PencilIcon />
        </button>
        <button className="btn btn-sm btn-ghost btn-square p-2 hover:bg-primary-400"
          title="Supprimer l'intervention"
          onClick={handleDeleteClick}
        >
          <TrashIcon />
        </button>
        {showConfirmDialog && (
            <dialog open className="modal">
              <div className="modal-box">
                <h3 className="font-bold text-lg">Confirmer la suppression</h3>
                <p className="py-4">Êtes-vous sûr de vouloir supprimer cette intervention ?</p>
                <p className="py-4 text-center">
                  Intervention de {item?.prestataire ? item.prestataire.nom_complet : 'prestataire non défini'}
                  {item?.date_intervention ? ` en date du ${formatDate(item.date_intervention)} ` : ' ' }
                  {item?.montant ? ` pour un montant de ${formatPrice(item.montant)}` : ''}
                </p>
                <div className="modal-action">
                  { deleting ? 
                    <button className="btn btn-secondary"><Spinner /></button> :
                    <button onClick={confirmDelete} className="btn btn-secondary">
                      Supprimer
                    </button>
                  }
                  <button onClick={cancelDelete} className="btn btn-outline">Annuler</button>
                </div>
              </div>
            </dialog>
          )}
      </div>

    </div>
  )
}